import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';
import { useTHelper } from 'src/utils/i18n';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['CrowdfundingRewardsSubSection'];
};

export const CheckoutConfirmCrowdfundingRewards = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.crowdfundingRewards');

  const columns = [
    { name: model.ItemsTerminology.Singular || '', className: 'left' },
    { name: tHelper('quantity'), className: 'align-center' },
    { name: tHelper('amount'), className: 'right' },
  ];

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      <CheckoutConfirmationTable columns={columns} data={model.Items}>
        {(item) => (
          <>
            <td className="left">{item.ItemTitle}</td>
            <td className="align-center">{item.Quantity}</td>
            <td className="right">
              {item.Amount * item.Quantity > 0
                ? commonFormatCurrencyWithType(item.Amount * item.Quantity, model.CurrencyType)
                : tHelper('free')}
            </td>
          </>
        )}
      </CheckoutConfirmationTable>
    </>
  );
});
